import { h } from "preact";
import { useState, useEffect, } from "preact/hooks";

import { ButtonGroup, Button, Typography } from "@mui/material";


export function TogglePlusMinus({ name, value, setUpperState }) {
    //const [state, setState] = useState({ nb: 0 });
    const handleChange = (event) => {

        setUpperState({ target: { name: name, value: event.target.value } });
    };
    return (
        <ButtonGroup variant="outlined" aria-label="outlined primary button group">
            <Button
                disabled={value ? (value > 0 ? false : true) : true}
                onClick={() => {
                    // setState({
                    //     ...state, nb: value - 1
                    // })
                    setUpperState({ target: { name: name, value: value - 1 } })
                }}><b>-</b></Button>
            <Button disabled  ><Typography variant="h5">{value ? value : 0}</Typography></Button>
            <Button onClick={() => {
                // setState({
                //     ...state, nb: value + 1
                // })
                setUpperState({ target: { name: name, value: value + 1 } })
            }}><b>+</b></Button>
        </ButtonGroup >

    );
}
